import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function checkTripSchedule(code: string) {
  return restApiClient.url(constructApiUrl(API.tripsSchedule.check.url, { code })).post()
}
